// ============================================================
// HlsEngine — Standard HLS (M3U8 v3, MPEG-TS, 2s chunks)
// ============================================================
import type { HlsConfig } from 'hls.js';
import { BaseHlsEngine } from './BaseHlsEngine';

export class HlsEngine extends BaseHlsEngine {
  readonly name = 'hls';
  readonly isLowLatency = false;

  protected getHlsConfig(): Partial<HlsConfig> {
    return {
      lowLatencyMode: false,

      // Sync window: 3 chunks from edge ≈ 6s for standard 2s segments
      liveSyncDurationCount: 3,
      liveMaxLatencyDurationCount: 5,

      // Treat live stream duration as infinite (prevents seekbar clamping)
      liveDurationInfinity: true,

      // Buffer tuning — enough for stable playback on standard HLS
      maxBufferLength: 10,
      maxMaxBufferLength: 20,


      // ABR — adaptive bitrate: auto-switch quality based on bandwidth
      abrEwmaDefaultEstimate: 500_000,   // 500kbps initial estimate
      abrBandWidthFactor: 0.95,          // switch down at 95% of level bitrate
      abrBandWidthUpFactor: 0.7,         // switch up at 70% of next level bitrate
      abrMaxWithRealBitrate: true,       // use measured bitrate for decisions

      // Manifest retries (keep alive during stream gaps)
      manifestLoadingMaxRetry: 60,
      manifestLoadingRetryDelay: 3000,
      manifestLoadingMaxRetryTimeout: 10000,

      // Level playlist retries
      levelLoadingMaxRetry: 30,
      levelLoadingRetryDelay: 2000,
      levelLoadingMaxRetryTimeout: 5000,

      startFragPrefetch: true,
      progressive: false,
      backBufferLength: 60,

      // Do not load media segments until play() is called
      autoStartLoad: false,

      debug: false,
    };
  }
}
